export function getById(list, selected_id, id_name) {
    if (list)
        return list.find(item => item[id_name] === selected_id);
    return [];
}

export function listFilter(list, selected_id, id_name) {
    if (list) {
        if (selected_id === 'all') {
            return list;
        }
        return list.filter(item => item[id_name] === selected_id);
    }
    return [];
}

export function includeString(main_string, sub_string) {
    return main_string && main_string.toLowerCase().includes(sub_string.toLowerCase());
}